import { defineComponent as _defineComponent } from 'vue'
import HeaderAdsBanner from './HeaderAdsBanner.vue';
import SsrRoot from 'JS/ssr/SsrRoot.vue';
import { HeaderAdsSsrRequest } from '../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAdsApp',
  props: {
    data: null
  },
  setup(__props: any) {



return { __sfc: true,HeaderAdsBanner, SsrRoot }
}

})